/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oB885NJtg5rwT11s7yCnwW
// Component: YWyR9ESU0CU

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ListSectionSeparator from "../../components/ListSectionSeparator"; // plasmic-import: uG5_fPM0sK/component
import ReferenceItem from "../../components/sidebar/ReferenceItem"; // plasmic-import: i-BferDjrAl/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: oB885NJtg5rwT11s7yCnwW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_find_references_modal.css"; // plasmic-import: oB885NJtg5rwT11s7yCnwW/projectcss
import sty from "./PlasmicFindReferencesModal.module.css"; // plasmic-import: YWyR9ESU0CU/css

createPlasmicElementProxy;

export type PlasmicFindReferencesModal__VariantMembers = {};
export type PlasmicFindReferencesModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicFindReferencesModal__VariantsArgs;
export const PlasmicFindReferencesModal__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFindReferencesModal__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicFindReferencesModal__ArgsType;
export const PlasmicFindReferencesModal__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicFindReferencesModal__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
};

export interface DefaultFindReferencesModalProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicFindReferencesModal__RenderFunc(props: {
  variants: PlasmicFindReferencesModal__VariantsArgs;
  args: PlasmicFindReferencesModal__ArgsType;
  overrides: PlasmicFindReferencesModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_oB885NJtg5rwT11s7yCnwW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__wCs9F
                )}
                selected={true}
                type={"page"}
              >
                {"Page"}
              </ReferenceItem>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__neR8
                )}
                type={"page"}
              >
                {"Page 2"}
              </ReferenceItem>
              <ListSectionSeparator
                center={true}
                className={classNames(
                  "__wab_instance",
                  sty.listSectionSeparator__fzv6I
                )}
              />

              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__vzlUr
                )}
                type={"component"}
              >
                {"Component"}
              </ReferenceItem>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__zvn0M
                )}
                type={"component"}
              >
                {"Component 2"}
              </ReferenceItem>
              <ListSectionSeparator
                center={true}
                className={classNames(
                  "__wab_instance",
                  sty.listSectionSeparator__ovwDe
                )}
              />

              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__hoMjp
                )}
                type={"token"}
              >
                {"Token"}
              </ReferenceItem>
              <ListSectionSeparator
                center={true}
                className={classNames(
                  "__wab_instance",
                  sty.listSectionSeparator__hxJsm
                )}
              />

              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__nvqG7
                )}
                type={"mixin"}
              >
                {"Mixin"}
              </ReferenceItem>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__llpa3
                )}
                type={"mixin"}
              >
                {"Mixin 2"}
              </ReferenceItem>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__fZfrj
                )}
                type={"mixin"}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__jtGud)}
                >
                  {"Mixin 3"}
                </div>
              </ReferenceItem>
              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__gaIcX
                )}
                type={"mixin"}
              >
                {"Mixin 4"}
              </ReferenceItem>
              <ListSectionSeparator
                center={true}
                className={classNames(
                  "__wab_instance",
                  sty.listSectionSeparator___67Frw
                )}
              />

              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__ohg1X
                )}
                type={"theme"}
              >
                {"Theme"}
              </ReferenceItem>
              <ListSectionSeparator
                center={true}
                className={classNames(
                  "__wab_instance",
                  sty.listSectionSeparator__lHr48
                )}
              />

              <ReferenceItem
                className={classNames(
                  "__wab_instance",
                  sty.referenceItem__l6IUh
                )}
                type={"preset"}
              >
                {"Preset"}
              </ReferenceItem>
            </React.Fragment>
          ),
          value: args.children,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFindReferencesModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFindReferencesModal__VariantsArgs;
    args?: PlasmicFindReferencesModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicFindReferencesModal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFindReferencesModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFindReferencesModal__ArgProps,
          internalVariantPropNames: PlasmicFindReferencesModal__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicFindReferencesModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFindReferencesModal";
  } else {
    func.displayName = `PlasmicFindReferencesModal.${nodeName}`;
  }
  return func;
}

export const PlasmicFindReferencesModal = Object.assign(
  // Top-level PlasmicFindReferencesModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicFindReferencesModal
    internalVariantProps: PlasmicFindReferencesModal__VariantProps,
    internalArgProps: PlasmicFindReferencesModal__ArgProps,
  }
);

export default PlasmicFindReferencesModal;
/* prettier-ignore-end */
